(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["headliners-jersey-editor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('headliners-jersey-editor')) {
  class HeadlinersJerseyEditor extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.section = document.getElementById('MainProduct-' + this.dataset.section);
      this.form = document.getElementById('product-form-' + this.dataset.section);
      if (!this.form) { this.started = false; requestAnimationFrame(() => this.connectedCallback()); return; }
      this.panel = this.querySelector('.hlj-panel');
      this.canvas = this.querySelector('canvas');
      this.ctx = this.canvas.getContext('2d');
      this.side = 'front'; this.layer = 'logo'; this.revision = 0; this.uploads = 0;
      this.states = {front:this.newSide('front'),back:this.newSide('back')};
      this.cache = new Map(); this.files = {}; this.base = {};
      this.fontCatalog=JSON.parse(this.querySelector('[data-font-catalog]').textContent);
      this.remoteFonts=new Map(this.fontCatalog.map(f=>['g:'+f[0],f]));
      this.fontLoads=new Map();this.fontReady=new Set();
      this.systemFonts=Array.from(this.panel.querySelector('[data-font=name]').options).map(o=>({value:o.value,label:o.textContent.trim()}));
      this.filterFonts('name');this.filterFonts('number');
      this.form.closest('product-form').before(this.panel);
      this.panel.hidden = false;
      this.abort = new AbortController();
      const on = (el,type,fn,extra={}) => el.addEventListener(type,fn,{signal:this.abort.signal,...extra});
      on(this,'click',e => { const b=e.target.closest('[data-side]'); if(b)this.setSide(b.dataset.side); });
      on(this.panel,'click',e => this.click(e));
      on(this.panel,'input',e => this.input(e));
      on(this.panel.querySelector('[data-upload]'),'change',e => this.upload(e));
      on(this.section,'change',() => setTimeout(() => this.syncColor(),0));
      on(this.form,'submit',e => this.submit(e),{capture:true});
      on(this.form,'formdata',e => this.serialize(e.formData));
      on(this.canvas,'pointerdown',e => this.pointerDown(e));
      on(this.canvas,'pointermove',e => this.pointerMove(e));
      on(this.canvas,'pointerup',() => { this.drag=null; });
      on(this.canvas,'pointercancel',() => { this.drag=null; });
      this.refresh(); this.syncColor();
    }
    disconnectedCallback() { this.abort?.abort(); this.panel?.remove(); }
    newSide(side) {
      return {name:'',number:'',fonts:{name:'block',number:'block'},logo:null,file:null,layers:{logo:{x:540,y:side==='front'?390:650,scale:100,rotation:0},name:{x:540,y:side==='back'?300:370,scale:100,rotation:0},number:{x:540,y:side==='front'?650:500,scale:100,rotation:0}}};
    }
    mappings() {
      return {
        'commando-competition-jersey':{'BLACK':['COMMANDOJERSEY-BLKFRNT','COMMANDOJERSEY-BLKBCK'],'ALPHA BLUE':['COMMANDOJERSEY-BLUFNT','COMMANDOJERSEY-BLUBCK'],'YELLOW FADE':['COMMANDOJERSEY-YELFNT','COMMANDOJERSEY-YELLOWBCK'],'RED':['COMMANDOJERSEY-REDFRNT','COMMANDOJERSEY-REDBCK'],'PURPLE':['COMMANDOJERSEY-PURPFNT','COMMANDOJERSEY-PURPBCK']},
        'raven-competition-jersey':{'BLACK':['HDV1JERSEY-VALBLKFRNT','HDV1JERSEY-VALBLKNCK'],'ALPHA BLUE':['HDV1JERSEY-BLUVALFRNT','HDV1JERSEY-VALB_UBCK'],'YELLOW FADE':['HDV1JERSEY-VALORGNFNT','HDV1JERSEY-VAL3DYBCK'],'CHAMELEON':['HDV1JERSEY-VALGRNFRNT','HDV1JERSEY-VALGRNBCK'],'PINK':['HDV1JERSEY-VALPNKFRNT','HDV1JERSEY-VALPNKBCK']},
        'flame-up-competition-jersey':{'BLACK':['HDV1JERSEY-FLAMESMOCKEFRNT','HDV1JERSEY-FLAMESMKDBCK'],'JOKERS AWAY':['HDV1JERSEY-FLAMEJOKERFRNT','HDV1JERSEY-FLAMEJKRBCK'],'AMERICANA':['HDV1JERSEY-FLAMEAMERICANA','HDV1JERSEY-FLAMEREDBCK']},
        'hdv1-competition-jersery':{'BLACK':['HALO1JERSEY-BLKFRNT','HALO1JERSEY-BLKBCK'],'ROYAL BLUE':['HALO1JERSEY-blufrbnt','HALO1JERSEY-blubck'],'RED':['HALO1JERSEY-redfrnt','HALO1JERSEY-redbck'],'SMOKED GREY':['HALO1JERSEY-blkblk','HALO1JERSEY-blkblkbck']}
      }[this.config.handle];
    }
    selectedColor() {
      const index=this.config.options.findIndex(o => /colou?r/i.test(o));
      const picker=this.section.querySelector('variant-radios,variant-selects');
      const sets=picker?.querySelectorAll('fieldset');
      const color=sets?.[index]?.querySelector('input:checked')?.value || picker?.querySelectorAll('select')[index]?.value;
      const variant=this.config.variants.find(v => String(v.id)===this.form.querySelector('[name=id]')?.value);
      return color || variant?.options[index];
    }
    syncColor() {
      const color=this.selectedColor();
      if(color===this.color)return;
      this.color=color; this.base={};
      this.querySelector('[data-color]').textContent=color || '';
      this.changed();
    }
    getImage(url) {
      if(!this.cache.has(url)) this.cache.set(url,new Promise((resolve,reject) => {
        const img=new Image(); img.crossOrigin='anonymous';
        img.onload=()=>resolve(img);img.onerror=()=>{this.cache.delete(url);reject(new Error('image'));};img.src=url;
      }));
      return this.cache.get(url);
    }
    async loadBase(color) {
      const names=this.mappings()?.[color];
      if(!names)throw new Error('color');
      const urls=names.map(n=>this.config.images.find(u=>new URL(u,location.origin).pathname.split('/').pop()===n+'.png'));
      if(urls.some(u=>!u))throw new Error('mockup');
      const images=await Promise.all(urls.map(u=>this.getImage(u)));
      return {front:images[0],back:images[1]};
    }
    setSide(side) { this.side=side;this.panel.querySelectorAll('[data-font-search]').forEach(i=>i.value='');this.filterFonts('name');this.filterFonts('number');this.refresh();this.draw(); }
    click(e) {
      const b=e.target.closest('button'); if(!b)return;
      if(b.dataset.side){this.setSide(b.dataset.side);return;}
      if(b.hasAttribute('data-view')){this.scrollIntoView({behavior:'smooth',block:'center'});return;}
      if(b.hasAttribute('data-remove')){this.states[this.side].logo=null;this.states[this.side].file=null;this.refresh();this.changed();}
      if(b.hasAttribute('data-reset')){this.states[this.side].layers[this.layer]=this.newSide(this.side).layers[this.layer];this.changed();this.refresh();}
      if(b.hasAttribute('data-clear')){this.states[this.side]=this.newSide(this.side);this.refresh();this.changed();}
      if(b.hasAttribute('data-retry'))this.changed();
    }
    input(e) {
      const s=this.states[this.side],t=e.target;
      if(t.dataset.fontSearch){this.filterFonts(t.dataset.fontSearch);return;}
      if(t.hasAttribute('data-name')){s.name=t.value;this.layer='name';}
      else if(t.hasAttribute('data-number')){t.value=t.value.replace(/\D/g,'').slice(0,3);s.number=t.value;this.layer='number';}
      else if(t.dataset.font){s.fonts[t.dataset.font]=t.value;this.layer=t.dataset.font;}
      else if(t.hasAttribute('data-layer')){this.layer=t.value;this.refresh();this.draw();return;}
      else if(t.hasAttribute('data-guide')){this.draw();return;}
      else if(t.dataset.control)s.layers[this.layer][t.dataset.control]=Number(t.value);
      else return;
      this.changed();this.refresh(false);
    }
    async upload(e) {
      const file=e.target.files[0],side=this.side,state=this.states[side];e.target.value='';
      if(!file)return;
      if(!['image/png','image/jpeg','image/webp'].includes(file.type)||file.size>20*1024*1024){this.status(this.config.text.file_error);return;}
      const token=Symbol();state.uploadToken=token;this.uploads++;this.changed();
      let finish;const completion=new Promise(resolve=>{finish=resolve;});
      this.pendingUploads ||= new Set();this.pendingUploads.add(completion);
      const url=URL.createObjectURL(file);
      try {
        const img=await this.getImage(url);
        if(img.naturalWidth*img.naturalHeight>40000000)throw new Error('dimensions');
        if(this.states[side]===state && state.uploadToken===token){state.logo=img;state.file=file;this.layer='logo';}
      } catch {this.status(this.config.text.file_error);}
      finally {URL.revokeObjectURL(url);this.cache.delete(url);this.uploads--;this.pendingUploads.delete(completion);finish();this.refresh();this.changed();}
    }
    refresh(text=true) {
      const s=this.states[this.side],q=sel=>this.panel.querySelector(sel);
      [...this.querySelectorAll('[data-side]'),...this.panel.querySelectorAll('[data-side]')].forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.side===this.side)));
      if(text){q('[data-name]').value=s.name;q('[data-number]').value=s.number;}
      this.panel.querySelectorAll('[data-font]').forEach(i=>i.value=s.fonts[i.dataset.font]);
      q('[data-filename]').textContent=s.file?.name || '';q('[data-remove]').hidden=!s.logo;
      const active=['logo','name','number'].filter(k=>!!s[k]);
      if(!active.includes(this.layer))this.layer=active[0] || 'logo';
      q('[data-adjust]').hidden=!active.length;
      q('[data-layer]').querySelectorAll('option').forEach(o=>o.disabled=!active.includes(o.value));q('[data-layer]').value=this.layer;
      q('[data-control="y"]').min=this.topBound(s,this.layer);
      this.panel.querySelectorAll('[data-control]').forEach(i=>i.value=s.layers[this.layer][i.dataset.control]);
    }
    filterFonts(key) {
      const select=this.panel.querySelector('[data-font="'+key+'"]'),search=this.panel.querySelector('[data-font-search="'+key+'"]').value.trim().toLowerCase();
      const chosen=this.states[this.side].fonts[key],fragment=document.createDocumentFragment();
      const options=[...this.systemFonts,...this.fontCatalog.map(f=>({value:'g:'+f[0],label:f[0]}))];
      for(const item of options)if(item.value===chosen||item.label.toLowerCase().includes(search)){
        const option=document.createElement('option');option.value=item.value;option.textContent=item.label;fragment.append(option);
      }
      select.replaceChildren(fragment);select.value=chosen;
    }
    textFont(s,key) {
      const size=key==='name'?42:150,remote=this.remoteFonts.get(s.fonts[key]);
      if(remote)return (remote[2]?'italic ':'')+remote[1]+' '+size+'px "'+remote[0]+'"';
      const family={block:'Arial, sans-serif',serif:'Georgia, serif',mono:'"Courier New", monospace',italic:'Arial, sans-serif'}[s.fonts[key]];
      return (s.fonts[key]==='italic'?'italic ':'')+'900 '+size+'px '+family;
    }
    fontLabel(s,key) { return this.remoteFonts.get(s.fonts[key])?.[0] || this.systemFonts.find(f=>f.value===s.fonts[key]).label; }
    async loadFont(s,key) {
      const id=s.fonts[key],font=this.remoteFonts.get(id);if(!font||!s[key])return;
      if(!this.fontLoads.has(id)){
        const promise=new Promise((resolve,reject)=>{
          const link=document.createElement('link');link.rel='stylesheet';
          const timer=setTimeout(()=>{link.remove();reject(new Error('font timeout'));},15000);
          link.onload=()=>{clearTimeout(timer);resolve();};link.onerror=()=>{clearTimeout(timer);link.remove();reject(new Error('font stylesheet'));};
          link.href='https://fonts.googleapis.com/css2?family='+encodeURIComponent(font[0])+(font[2]?':ital,wght@1,':':wght@')+font[1]+'&display=block';document.head.append(link);
        }).catch(error=>{this.fontLoads.delete(id);throw error;});
        this.fontLoads.set(id,promise);
      }
      await this.fontLoads.get(id);
      const faces=await document.fonts.load(this.textFont(s,key),s[key]);
      if(!faces.length)throw new Error('font unavailable');
      this.fontReady.add(id);
    }
    topBound(s,key) { if(s===this.states.back && key==='name')return 260;if(s===this.states.front && key==='logo')return 280;return 340; }
    textGeometry(s,key) {
      this.ctx.font=this.textFont(s,key);this.ctx.textAlign='center';this.ctx.textBaseline='alphabetic';
      const m=this.ctx.measureText(s[key]),left=m.actualBoundingBoxLeft||0,right=m.actualBoundingBoxRight||0,up=m.actualBoundingBoxAscent||0,down=m.actualBoundingBoxDescent||0;
      return {w:Math.max(1,left+right,m.width),h:Math.max(1,up+down),dx:(left-right)/2,dy:(up-down)/2};
    }
    dimensions(s,key) {
      const layer=s.layers[key],scale=layer.scale/100;
      let w,h;
      if(key==='logo'){const ratio=s.logo.naturalWidth/s.logo.naturalHeight;w=Math.min(250,210*ratio)*scale;h=w/ratio;}
      else {const g=this.textGeometry(s,key);w=g.w*scale;h=g.h*scale;}
      const a=layer.rotation*Math.PI/180,c=Math.abs(Math.cos(a)),n=Math.abs(Math.sin(a));
      const factor=Math.min(1,324/(w*c+h*n),394/(h*c+w*n));w*=factor;h*=factor;
      const bx=(w*c+h*n)/2+8,by=(h*c+w*n)/2+8;
      layer.x=Math.max(370+bx,Math.min(710-bx,layer.x));layer.y=Math.max(this.topBound(s,key)+by,Math.min(750-by,layer.y));
      return {w,h,a};
    }
    render(canvas,side,guide=false) {
      const ctx=canvas.getContext('2d'),s=this.states[side];ctx.clearRect(0,0,1080,1080);
      if(!this.base[side])return;
      ctx.drawImage(this.base[side],0,0,1080,1080);
      for(const key of ['logo','name','number']){
        if(!s[key])continue;
        const l=s.layers[key],d=this.dimensions(s,key);ctx.save();ctx.translate(l.x,l.y);ctx.rotate(d.a);
        if(key==='logo')ctx.drawImage(s.logo,-d.w/2,-d.h/2,d.w,d.h);
        else{const g=this.textGeometry(s,key);ctx.font=this.textFont(s,key);ctx.textAlign='center';ctx.textBaseline='alphabetic';ctx.scale(d.w/g.w,d.h/g.h);ctx.lineJoin='round';ctx.lineWidth=key==='name'?3:6;ctx.strokeStyle='#101010';ctx.fillStyle='#ffffff';ctx.strokeText(s[key],g.dx,g.dy);ctx.fillText(s[key],g.dx,g.dy);}
        ctx.restore();
      }
      if(guide){ctx.save();ctx.setLineDash([10,8]);ctx.strokeStyle='#3affd5';ctx.lineWidth=3;ctx.strokeRect(370,this.topBound(s,this.layer),340,750-this.topBound(s,this.layer));ctx.restore();}
    }
    draw(){const s=this.states[this.side];if(['name','number'].some(k=>s[k]&&this.remoteFonts.has(s.fonts[k])&&!this.fontReady.has(s.fonts[k])))return;this.render(this.canvas,this.side,this.panel.querySelector('[data-guide]').checked);}
    point(e){const r=this.canvas.getBoundingClientRect();return{x:(e.clientX-r.left)*1080/r.width,y:(e.clientY-r.top)*1080/r.height};}
    pointerDown(e){if(!this.states[this.side][this.layer])return;const p=this.point(e),l=this.states[this.side].layers[this.layer];this.drag={dx:p.x-l.x,dy:p.y-l.y};this.canvas.setPointerCapture(e.pointerId);}
    pointerMove(e){if(!this.drag)return;const p=this.point(e),l=this.states[this.side].layers[this.layer];l.x=p.x-this.drag.dx;l.y=p.y-this.drag.dy;this.changed();this.refresh(false);}
    customized(){return Object.values(this.states).some(s=>s.logo||s.name||s.number);}
    status(text){this.panel.querySelector('[data-status]').textContent=text;}
    changed(){
      this.revision++;this.readyRevision=-1;this.files={};this.draw();
      const pay=this.form.querySelector('.shopify-payment-button');if(pay)pay.hidden=this.customized();
      this.status(this.config.text.loading);this.panel.querySelector('[data-retry]').hidden=true;
      clearTimeout(this.timer);this.timer=setTimeout(()=>this.prepare(),180);
    }
    async prepare(){
      const revision=this.revision,color=this.color;
      try{
        const [base]=await Promise.all([this.loadBase(color),...Object.values(this.states).flatMap(s=>['name','number'].map(k=>this.loadFont(s,k)))]);
        if(revision!==this.revision||this.uploads)return false;
        this.base=base;this.draw();
        const files={};
        if(this.customized())for(const side of ['front','back']){
          const c=document.createElement('canvas');c.width=c.height=1080;this.render(c,side);
          const blob=await new Promise(resolve=>c.toBlob(resolve,'image/png'));
          if(!blob)throw new Error('export');files[side]=new File([blob],this.config.handle+'-'+side+'-preview.png',{type:'image/png'});
        }
        if(revision!==this.revision||this.uploads)return false;
        this.files=files;this.readyRevision=revision;this.status(this.config.text.ready);return true;
      }catch{if(revision===this.revision){this.status(this.config.text.error);this.panel.querySelector('[data-retry]').hidden=false;}return false;}
    }
    async submit(e){
      this.syncColor();
      if(!this.customized()&&!this.uploads)return;
      if(this.readyRevision===this.revision&&!this.uploads)return;
      e.preventDefault();e.stopImmediatePropagation();
      if(this.submitting)return;
      this.submitting=true;this.status(this.config.text.loading);clearTimeout(this.timer);
      await Promise.all([...(this.pendingUploads || [])]);this.syncColor();
      const ready=await this.prepare();this.submitting=false;
      if(ready)this.form.requestSubmit(e.submitter || undefined);
    }
    serialize(data){
      if(!this.customized())return;
      if(this.readyRevision!==this.revision)throw new Error('Jersey design is not ready');
      const put=(key,value)=>data.set('properties['+key+']',value);
      put('Jersey color',this.color);
      for(const side of ['front','back']){
        const s=this.states[side],label=side==='front'?'Front':'Back';
        if(s.file)put(label+' logo',s.file);
        if(s.name){put(label+' name',s.name);put(label+' name font',this.fontLabel(s,'name'));}
        if(s.number){put(label+' number',s.number);put(label+' number font',this.fontLabel(s,'number'));}
        put(label+' design preview',this.files[side]);
      }
      put('_Jersey layout',JSON.stringify({version:3,canvas:1080,color:this.color,fonts:{front:{name:this.textFont(this.states.front,'name'),number:this.textFont(this.states.front,'number')},back:{name:this.textFont(this.states.back,'name'),number:this.textFont(this.states.back,'number')}},textFill:'#ffffff',textOutline:'#101010',front:this.states.front.layers,back:this.states.back.layers}));
    }
  }
  customElements.define('headliners-jersey-editor',HeadlinersJerseyEditor);
}
  } catch(e) { console.error(e); }
})();

})();
